export const defaultTemplateSchema: any = [];
export const layout = {
   labelCol: { span: 6 },
   wrapperCol: { span: 14 }
};
